import {NgModule} from "@angular/core";
import {AvtaleGodtaLisensbetingelserDialogKomponentAvhengigheter} from "./modale/avtale-godta-lisensbetingelser-dialog/avtale-godta-lisensbetingelser-dialog";
import {TerminerAvtaleKomponentAvhengigheter} from "web-ng2/moduler/avtale/komponenter/terminer-avtale/terminer-avtale";
import {RedigerAvtaleKomponentAvhengigheter} from "web-ng2/moduler/avtale/komponenter/rediger-avtale/rediger-avtale";

@NgModule({
    providers: [
        AvtaleGodtaLisensbetingelserDialogKomponentAvhengigheter,
        TerminerAvtaleKomponentAvhengigheter,
        RedigerAvtaleKomponentAvhengigheter
    ]
})
export class AvtaleModul {

}
